import React from 'react'
import { Checkbox } from '../../../legacy-design-system/checkbox'
import { HelpText } from './help-text'
import { ContrastFormattedMessage } from '../../contrast-formatted-message'

export function SamplingToggleInput({
  disabled,
  onEdit,
  disableSamplingToggle,
  value,
  edited,
  onChange,
  setRef
}: {
  readonly value: boolean
  readonly disabled: boolean
  readonly edited: boolean
  readonly onChange: (value: boolean) => void
  readonly onEdit?: () => void
  readonly disableSamplingToggle: boolean
  readonly setRef?: (ref) => void
}) {
  return (
    <ContrastFormattedMessage id="detail_enableSampling_checkbox">
      {(samplingLabel) => (
        <Checkbox
          disabled={disabled}
          onEdit={onEdit}
          id="serverSettings_sampling"
          label={samplingLabel}
          value={value}
          onChange={onChange}
          renderHelpContent={() => (
            <ContrastFormattedMessage
              id={
                disableSamplingToggle
                  ? 'detail_servers_enableAssessToEnableSampling'
                  : 'detail_servers_enableSamplingDescription'
              }
            >
              {(message) => <HelpText>{message}</HelpText>}
            </ContrastFormattedMessage>
          )}
          inputRef={setRef}
          edited={edited}
        />
      )}
    </ContrastFormattedMessage>
  )
}
